<template xmlns:el-col="http://www.w3.org/1999/html">
  <div class="container h-100">
    <div class="content">
      <div class="header">
        <el-row>
          <!--          <el-col :span="24">-->
          <!--            <el-divider content-position="left">-->
          <!--              <div style="display: inline-block">-->
          <!--                <el-link :underline="true" @click="initList">申请开票 <i class="el-icon-refresh"></i></el-link>-->
          <!--              </div>-->
          <!--            </el-divider>-->
          <!--          </el-col>-->
          <el-col :span="24">
            <el-form :model="searchCondition" :inline="true" size="mini" @submit.native.prevent>
              <el-form-item label="">
                <el-select v-model="searchCondition.invoice_status" placeholder="开票状态"
                           @change="onSubmit" multiple
                           :collapse-tags="true" clearable>
                  <!--                    <el-option label="全部" value=""></el-option>-->
                  <el-option :label="item.label" :value="item.value"
                             v-for="(item,index) in optionsMap.invoiceStatusOptions"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="searchCondition.contract_filed" placeholder="合同归档"
                           style="width: 120px"
                           @change="onSubmit" clearable>
                  <el-option :value="item.value" :label="item.label"
                             v-for="(item,key) in optionsMap.contractOptions"
                             :key="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="searchCondition.contract_no" placeholder="请输入合同编号"
                          @change="onSubmit"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="searchCondition.order_no" placeholder="订单编号:精确搜索"
                          @change="onSubmit"
                          clearable></el-input>
              </el-form-item>
              <el-form-item label="">
                <CustomerSearch :name="searchKeyword" style="width: 240px" clearable
                                @handleSelect="handleSelect"/>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                &nbsp;
                <el-link type="primary" @click="showCondDrawer=!showCondDrawer">更多查询<i
                    :class="showCondDrawer?'el-icon-arrow-up':'el-icon-arrow-down'"/></el-link>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="15" style="margin-bottom: 8px">
        <el-col :span="1.5">
          <!--          申请开票-->
          <ApplyInvoiceOpt :data-list="selectedData" @applied="afterDeal"/>
        </el-col>
        <el-col :span="1.5">
          <!--          标记开票-->
          <MarkOrderInvoiceOpt :data-list="selectedData" @marked="afterDeal"/>
        </el-col>
      </el-row>
      <div v-loading="loading"
           element-loading-text="订单加载中……"
           element-loading-spinner="el-icon-loading" class="default-table">
        <el-table
            ref="tableApply"
            :data="dataList"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            @select-all="HandleSelectAll"
            @select="HandleSelectRow"
            border>
          <el-table-column
              type="selection"
              :selectable="checkSelectable"
              width="55"
              title="常规订单/未开票/未撤单"
          />
          <el-table-column
              label="序号"
              width="60"
              header-align="center"
              align="center"
          >
            <template slot-scope="{$index}">
              <span>{{ offset + $index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="can_do"
              label="可开票"
              width="70"
              header-align="center"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
                <span :title="`可开票条件：常规订单/未开票/未撤单`">
<!--                   <span v-if="scope.row.order_type ==='regular' && ['done', 'apply', 'pass'].indexOf(scope.row.invoice_status) === -1 && !scope.row.bool_undo">-->
                  <!--                     <el-tag type="success" size="mini" effect="plain">是</el-tag>-->
                  <!--                    </span>-->
                    <span v-if="scope.row.can_do">
                        <el-tag type="success" size="mini" effect="plain">是</el-tag>
                    </span>
                    <span v-else>
                        <el-tag type="info" size="mini" effect="plain">否</el-tag>
                    </span>
                    <span v-if="scope.row.bool_undo">已撤单</span>
                </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="can_do"
              label="开票状态"
              width="110"
              header-align="center"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
                <span :title="`可开票条件：常规订单/未开票/未撤单`">
                     <span class="status_alias">{{ scope.row.invoice_status_alias }}</span>
                </span>
            </template>
          </el-table-column>
          <el-table-column
              prop="order_no"
              label="订单编号"
              width="140"
              header-align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="customer_name"
              label="客户名称"
              width="260"
              header-align="center"
              sortable
              :show-tooltip-when-overflow="true">
            <template slot-scope="{row}">
               <span style="padding: 2px 2px; background-color: #ff3176; color: #fff; font-size: 12px;"
                     v-show="row.is_mark==1"
               >全案
                  <span>{{ row.pid === 0 ? '主' : '子' }}</span>
                </span>
              {{ row.customer_name }}
            </template>
          </el-table-column>
          <el-table-column
              prop="created_timestamp"
              label="下单时间"
              width="90"
              header-align="center"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="release_timestamp"
              label="发布时间"
              width="90"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="exec_timestamp"
              label="执行时间"
              width="90"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="payed_timestamp"
              label="结款时间"
              width="90"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="payment_account"
              label="含税收入"
              width="100"
              header-align="center"
              align="right"
              :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <span class="money">{{ moneyFormat(scope.row.payment_account) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="invoice_money_done"
              label="已申请金额"
              width="110"
              header-align="center"
              align="right"
              :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <span class="money">{{ moneyFormat(scope.row.invoice_money_done) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="invoice_money_occupy"
              label="申请中金额"
              width="110"
              header-align="center"
              align="right"
              :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <span class="money">{{ moneyFormat(scope.row.invoice_money_occupy) }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="sum_amount"
              label="回款金额"
              width="100"
              header-align="center"
              align="right"
              :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <span class="money">{{ moneyFormat(scope.row.sum_amount) }}</span>
            </template>
          </el-table-column>
          <!--            <el-table-column-->
          <!--                prop="invoice_money"-->
          <!--                label="发票金额"-->
          <!--                width="100"-->
          <!--                header-align="center"-->
          <!--                align="right"-->
          <!--                :show-tooltip-when-overflow="true">-->
          <!--            </el-table-column>-->
          <el-table-column
              prop="order_source"
              label="订单来源"
              width="120"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="brand"
              label="品牌"
              width="100"
              header-align="center"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="product"
              label="产品/内容"
              width="120"
              header-align="center"
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="trade"
              label="行业"
              width="100"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="pay_status_alias"
              label="回款状态"
              width="100"
              align="center"
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="contract_filed_alias"
              label="归档状态"
              width="80"
              align="center"
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="contract_no"
              label="合同编号"
              width="100"
              header-align="center"
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="invoice_status_alias"
              label="开票状态"
              width="100"
              header-align="center"
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="bool_undo_alias"-->
          <!--              label="是否撤单"-->
          <!--              width="100"-->
          <!--              header-align="center"-->
          <!--              :show-tooltip-when-overflow="true">-->
          <!--          </el-table-column>-->
          <el-table-column
              prop="creator"
              label="建单人"
              width="100"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="sale"
              label="销售"
              width="100"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="executor"
              label="执行人"
              width="100"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="artist_name"
              label="红人"
              width="100"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="agent_name"
              label="经纪人"
              width="100"
              align="center"
              sortable
              :show-tooltip-when-overflow="true">
          </el-table-column>
          <el-table-column
              prop="remark"
              label="备注"
              min-width="200"
              header-align="center"
              align="left" :show-tooltip-when-overflow="true">
            <template slot-scope="scope">
              <span style="font-weight: lighter">{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-footer">
          <el-row>
            <el-col :span="12">
              <div class="bottom-bar">
                <div>
                  <el-button size="mini" @click="clearData" :disabled="previewOrderTotal===0">
                    清空已选
                  </el-button>
                </div>
                <div style="cursor: pointer;font-size: 1rem;font-style: italic;margin-left: 10px;padding-top: 5px">
                  <div style="font-weight: bold;display: flex">
                  <span style="margin-right: 10px">总含税收入：<span class="money" style="font-size: 1.2rem">{{
                      moneyFormat(paymentAccountTotal)
                    }}</span></span>
                    <span style="margin-right: 10px">已选订单数：<span
                        style="font-size: 1.2rem;color:#ff3176 ">{{ previewOrderTotal }} </span>条</span>
                    <span style="margin-right: 10px">平均含税收入：<span class="money"
                                                                        style="font-size: 1.2rem">{{
                        moneyFormat(previewOrderTotal > 0 ? paymentAccountTotal / previewOrderTotal : '--')
                      }}</span>
                  </span>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <Pagination :total="total" :limit.sync="pagingData.per_page"
                          :page.sync="pagingData.page" @pagination="initList"></Pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--    筛选条件 -->
    <el-drawer
        title="筛选条件"
        size="600px"
        append-to-body
        :visible.sync="showCondDrawer"
        :direction="direction">
      <template slot="title">
        <span style="font-weight: bold;font-size: 1.5em">筛选条件</span>
      </template>
      <div style="padding: 5px">
        <el-form ref="searchCondition" size="small" :model="searchCondition" label-width="100px">
          <el-form-item label="检索客户">
            <CustomerSearch :name.sync="searchKeyword" style="width: 100%" clearable
                            @handleSelect="handleSelect"/>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="searchCondition.customer_name" clearable></el-input>
          </el-form-item>
          <el-form-item label="开票状态">
            <el-select v-model="searchCondition.invoice_status" multiple :collapse-tags="true"
                       placeholder="请选择开票状态"
                       clearable>
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.label" :value="item.value"
                         v-for="(item,index) in optionsMap.invoiceStatusOptions" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回款状态" class="search-item">
            <el-select v-model="searchCondition.pay_status" clearable>
              <el-option :value="item.value" :label="item.label"
                         v-for="(item,key) in optionsMap.payStatusOptions"
                         :key="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同归档" class="search-item">
            <el-select v-model="searchCondition.contract_filed" clearable>
              <el-option :value="item.value" :label="item.label"
                         v-for="(item,key) in optionsMap.contractOptions"
                         :key="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号" class="search-item">
            <el-input v-model="searchCondition.contract_no" placeholder="请输入合同编号"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="时间筛选">
            <el-row :gutter="5">
              <el-col :span="6">
                <el-select v-model="searchCondition.time_type" clearable>
                  <el-option value="created_timestamp" label="下单时间"></el-option>
                  <el-option value="exec_timestamp" label="执行时间"></el-option>
                  <el-option value="payed_timestamp" label="结款时间"></el-option>
                  <el-option value="release_timestamp" label="发布时间"/>
                </el-select>
              </el-col>
              <el-col :span="16">
                <el-date-picker
                    v-model="searchCondition.time_value"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="匹配销售">
            <UserSearch :name.sync="searchSaleKeyword" style="width: 260px" clearable
                        @handleSelect="handleSaleSelect"/>
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input v-model="searchCondition.order_no" placeholder="精确搜索" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" class="el-button--operation">筛选</el-button>
            <el-button @click="clearCondition">全部清除</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>

    <!--    发票信息-->
    <el-dialog title="发票信息" :visible.sync="dialogInvoice" custom-class="invoice-dialog"
               :close-on-click-modal="false">
      <div class="d-flex-column d-flex-center" style="padding: 0px 24px;">
        <InvoiceApply ref="refInvoiceApply" @showErrorEvent="showInvoiceFail" @showedEvent="showInvoiceSuccess"
                      @submited="afterSubmitInvoice" @closeEvent="closeInvoiceDialog"></InvoiceApply>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {getDirectOrders,} from "@/api/bill";
import InvoiceApply from "@/views/bill/components/InvoiceApply";
import ApplyInvoiceOpt from "@/views/adOrder/components/ApplyInvoiceOpt";
import MarkOrderInvoiceOpt from "@/views/adOrder/components/MarkOrderInvoiceOpt";
import {numberFormat} from "@/utils/index.js";

export default {
  name: "BillApply",
  components: {
    MarkOrderInvoiceOpt,
    ApplyInvoiceOpt,
    InvoiceApply,
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
    user() {
      return this.$store.getters.getUser;
    },
    headerToken() {
      return {
        Authorization: "Bearer " + this.getToken()
      }
    },
    // 已分配金额计算
    totalPayment() {
      // 计算剩余可分配金额
      let total = 0
      this.multipleSelection.forEach((item) => {
        total += item.payment * 1
      })
      return total
    },
    //计算总含税收入
    paymentAccountTotal() {
      let total = 0;
      this.selectedData.forEach((row) => {
        total += row.payment_account / 1
      })
      return total
    },
    previewOrderTotal() {
      return this.selectedData.length
    },
  },

  data() {
    return {
      invoiceLoadding: false,//申请发票
      dialogInvoice: false,
      //直接开票
      directDoneInvoiceLoading: false,//添加开票记录
      loading: false,//数据加载中
      tableRef: 'tableApply',
      total: 0,
      offset: 0,
      // 分页信息
      pagingData: {
        // is_show: true,
        // layout: 'total, sizes, prev, pager, next, jumper',
        // total: 0,
        // page_size: 25,
        per_page: 20,
        page: 1,
      },
      dataList: [],
      selectedData: [],
      multipleSelection: [],//修改的记录
      showCondDrawer: false,
      direction: 'rtl',
      searchKeyword: '',
      searchSaleKeyword: '',
      searchCondition: {
        invoice_status: ['none', 'part',],
        order_no: null,
        sale_id: null,
        customer_id: null,
        customer_name: null,
        contract_filed: null,
        contract_no: null,
        pay_status: null,
        time_type: 'payed_timestamp',
        time_value: [],
      },
      payMethodOptions: [
        // {value: '', label: '全部'},
        // {value: '银行收款', label: '银行收款'},
        // {value: '平台提现', label: '平台提现'},
        // {value: '支付宝', label: '支付宝'},
        // {value: '微信', label: '微信'},
        // {value: '银联', label: '银联'},
        // {value: '现金', label: '现金'},
      ],
      dialogVisible: false,// 确认认领的数据
      currentRecord: {payer: '', bank_name: '', pay_date: '', pay_method: '', account: 0},//当前选中的记录
      loadingOrder: false,//加载
      orders: [],//匹配的订单列表

      formOrder: {
        record_id: null,
        customer_name: '',
        artist_name: '',
        platforms: '',
        product: '',
        pay_status: null,
        bool_exec: null
      },//订单筛选条件
        //下拉框数据
      optionsMap: {
        // boolExecOptions: [
        //   { label: '已执行', value: 1 },
        //   { label: '未执行', value: 0 },
        // ],
        contractOptions: [
          {label: '未归档', value: 0},
          {label: '已归档', value: 1},
        ],
        payStatusOptions: [
          {label: '已完结', value: 2},
          {label: '部分回款', value: 1},
          {label: '待回款', value: 0},
        ],
        invoiceStatusOptions: [
          {label: '未开票', value: 'none'},
          {label: '部分开票', value: 'part'},
          {label: '全部开票', value: 'done'},
        ]
      },
    }
  },
  created() {
    this.initList()
  },
  methods: {
    moneyFormat(value) { // 金额 格式化
      return numberFormat(value,2,'.',',','round')
    },
    onSubmit() {
      this.showCondDrawer = false
      this.initList()
    },
    clearCondition() {
      this.searchCondition = {
        payer: '',
        claim_status: null,
        time_value: [],
        pay_method: ''
      }
      this.initList()
    },
    initList() {
      this.loading = true
      this.dataList = []
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, this.pagingData)
      getDirectOrders(searchCondition).then((res) => {
        this.loading = false
        if (res.model) {
          let model = res.model
          this.dataList = model.data
          this.total = model.total * 1
          this.pagingData.per_page = model.per_page * 1
          this.offset = this.pagingData.per_page * (this.pagingData.page - 1)
        }
        this.toggleSelection()
      });
    },

    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}

      if (this.searchCondition.invoice_status) {
        condition.invoice_status = this.searchCondition.invoice_status
      }
      if (this.searchCondition.customer_name) {
        condition.customer_name = this.searchCondition.customer_name
      }
      if (this.searchCondition.customer_id) {
        condition.customer_id = this.searchCondition.customer_id
      }
      if (this.searchCondition.sale_id) {
        condition.sale_id = this.searchCondition.sale_id
      }
      if (this.searchCondition.order_no) {
        condition.order_no = this.searchCondition.order_no
      }
      if (this.searchCondition.pay_status) {
        condition.pay_status = this.searchCondition.pay_status
      }

      if (this.searchCondition.contract_filed) {
        condition.contract_filed = this.searchCondition.contract_filed
      }

      if (this.searchCondition.contract_no) {
        condition.contract_no = this.searchCondition.contract_no
      }

      if (this.searchCondition.time_type) {
        condition.time_type = this.searchCondition.time_type
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      return condition
    },
    tableRowClassName({row, rowIndex}) {
      // // 把每一行的索引放进row.id
      row.index = rowIndex + 1
    },
    checkSelectable(row) {
      // 常规订单/未开票/未撤单
      return row.can_do;
    },
    selectInput(row, index) {
      this.$refs.ordersTable.toggleRowSelection(
        this.orders[index - 1],
        true
      )
    },
    // 勾选事件
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.appendToSelectedData(val)
    },
    appendToSelectedData(val) {
      if (val.length > 0) {
        val.forEach((row) => {
          const currentIdIndex = this.selectedData.findIndex(value => value.id === row.id)
          if (currentIdIndex === -1) {
            this.selectedData.push({...row})
          }
        })
      }
    },
    //当选择项发生变化时会触发该事件
    HandleSelectAll(selection) {
      // console.log(selection)
      if (selection.length === 0) {
        //取消全选
        // console.log('取消全选')
        // 取消的数据对象 dataList
        this.dataList.forEach((row) => {
          let index = this.selectedData.findIndex(value => value.id === row.id)
          if (index > -1)
            this.selectedData.splice(index, 1)
        })

      }
    },
    // 行选中、取消选中
    HandleSelectRow(selection, row) {
      if (selection.indexOf(row) === -1) {
        //row 取消选中
        // console.log('取消选中')
        let index = this.selectedData.findIndex(value => value.id === row.id)
        // this.$notify.info(`取消第${index}行`)
        if (index > -1)
          this.selectedData.splice(index, 1)
      }
    },
    // 渲染选中
    toggleSelection() {
      const data = this.dataList ? this.dataList : [];
      this.$nextTick(function () {
        data.forEach(row => {
          if (this.selectedData.findIndex(value => value.id === row.id) > -1) {
            this.switchRowSelection(row, true)
          }
        });
      });
    },
    switchRowSelection(row, bool) {
      this.$refs[this.tableRef].toggleRowSelection(row, bool)
    },
    //清空选中
    handleClearSelection() {
      // this.$refs[this.tableRef].handleClearSelection()
      this.$refs[this.tableRef].clearSelection()
    },
    clearData() {
      this.selectedData = []
      this.multipleSelection = []
      this.handleClearSelection()
    },
    // 处理搜索结果的选中
    handleSelect(item) {
      if (item.id) {
        this.searchCondition.customer_id = item.id
      } else {
        this.searchCondition.customer_id = null
      }
      if (!this.showCondDrawer)
        this.onSubmit()
    },
    // 处理搜索结果的选中
    handleSaleSelect(item) {
      if (item.id) {
        this.searchCondition.sale_id = item.id
      } else {
        this.searchCondition.sale_id = null
      }
    },
    afterDeal() {
      this.clearData()
      this.initList()
    },
    // 申请开票
    invoiceApplyBtn() {
      // this.invoiceLoadding = true;
      this.dialogInvoice = true;
      // let _selectItems = this.multipleSelection
      let _selectItems = this.selectedData
      this.$nextTick(() => {
        this.$refs['refInvoiceApply'].showReceipt(_selectItems)
      })
    },
    //发票信息：展示失败
    showInvoiceFail(error_msg) {
      this.showToast({
        h: this,
        icon: "el-icon-error",
        text: error_msg,
        duration: 2000
      });
      this.closeInvoiceDialog()
    },
    //发票信息：展示成功
    showInvoiceSuccess() {

    },
    //发票信息：提交成功
    afterSubmitInvoice() {
      this.closeInvoiceDialog()
      this.clearData()
      this.initList()
    },
    closeInvoiceDialog() {
      this.dialogInvoice = false;
    },
  }
}
</script>

<style scoped>
.header {
    background: #fff;
    /*padding: 0px 30px 0 30px;*/
    /*border-bottom: 1px solid #F2F2F2;*/
}

.status_alias {
    font-size: 0.9rem;
    font-weight: 400;
    padding-left: 5px;
    font-style: italic;
}

.page-footer {
    height: 50px;
    width: 100%;
    position: fixed;
    bottom: 1px;
    background-color: #FFFFFF;
    opacity: 0.9;
    z-index: 999;
}

.bottom-bar {
    width: 100%;
    /*margin-top: 10px;*/
    text-align: left !important;
    padding: 10px 10px 0 1px;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    /*position: fixed;bottom: 1px;*/
    /*background: #FFFFFF;*/
    /*z-index: 99999;*/
    /*opacity: 0.75;*/
}
</style>

